import { CheckCircle, Loader2, TrendingUp, Users } from 'lucide-react';
import React from 'react';
import { SimpleMetricCard } from './SimpleMetricCard';

/**
 * PeopleSearchMetrics Component
 * Displays 4 metric cards for People Search statistics
 * Matches the people-search-mockup.html design exactly
 *
 * @param {Object} props
 * @param {number} props.totalFound - Total candidates found
 * @param {number} props.processed - Number of processed candidates
 * @param {number} props.processing - Number of candidates being processed
 * @param {number} props.avgMatch - Average match percentage
 */
export function PeopleSearchMetrics({
  totalFound = 0,
  processed = 0,
  processing = 0,
  avgMatch = 0
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 animate-fade-in">
      {/* Total Found */}
      <SimpleMetricCard
        title="Total Found"
        value={totalFound}
        icon={Users}
        iconBgColor="bg-blue-100"
        iconColor="text-blue-600"
      />

      {/* Processed */}
      <SimpleMetricCard
        title="Processed"
        value={processed}
        icon={CheckCircle}
        iconBgColor="bg-green-100"
        iconColor="text-green-600"
      />

      {/* Avg Match */}
      <SimpleMetricCard
        title="Avg Match"
        value={`${avgMatch}%`}
        icon={TrendingUp}
        iconBgColor="bg-orange-100"
        iconColor="text-orange-600"
      />

      {/* Processing */}
      <SimpleMetricCard
        title="Processing"
        value={processing}
        icon={processing > 0 ? Loader2 : CheckCircle}
        iconBgColor="bg-purple-100"
        iconColor={processing > 0 ? "text-purple-600 animate-spin" : "text-purple-600"}
      />
    </div>
  );
}

